// next
// @mui
import { Card, CardContent, Container, Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// layouts
import Image from '../components/Image';
import Layout from '../layouts';
// components
import Page from '../components/Page';
//
import TextMaxLine from '../components/TextMaxLine';
import useLocales from '../hooks/useLocales';
import useSettings from '../hooks/useSettings';
import Welcome from '../sections/download/Welcome';

const data = [
  {
    id: 1,
    image: 'oto',
    title: 'THI GPLX Ô TÔ & MÔ PHỎNG',
    description:
      'Tích hợp các chức năng đánh giá và thống kê kết quả, ứng dụng thi lý thuyết giấy phép lái xe ô tô cho phép người dùng theo dõi tiến độ học tập của mình và cảm nhận sự tiến bộ từng ngày, đồng thời tăng cường sự tự tin trước khi tham gia kỳ thi thực tế.',
    ios: 'https://apps.apple.com/us/app/id6461346495',
    android: 'https://play.google.com/store/apps/details?id=onthibanglaixe.net.gplx'
  },
  {
    id: 2,
    image: 'xemay',
    title: 'THI GPLX XE MÁY',
    description:
      'Với các chế độ học tập linh hoạt và cơ chế theo dõi tiến độ, ứng dụng thi lý thuyết giấy phép lái xe máy giúp người dùng nâng cao sự tự tin và chuẩn bị tốt nhất cho kỳ thi giấy phép lái xe máy',
    ios: 'https://apps.apple.com/us/app/id6459738600',
    android: 'https://play.google.com/store/apps/details?id=onthibanglaixe.net.xemay'
  },
  {
    id: 3,
    image: 'mophong',
    title: 'THI MÔ PHỎNG Ô TÔ',
    description:
      'Phần mềm thi thử mô phỏng 120 tình huống giao thông online của chúng tôi được phát triển dựa trên phần mềm offline do Tổng Cục Đường Bộ Việt Nam ban hành trước đó.',
    ios: 'https://apps.apple.com/us/app/id6450710245',
    android: 'https://play.google.com/store/apps/details?id=onthibanglaixe.net.thimophong'
  },
];

// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));
// ----------------------------------------------------------------------

DownloadApp.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};
// ----------------------------------------------------------------------

export default function DownloadApp() {
  const { translate } = useLocales();
  const { themeStretch } = useSettings();

  return (
    <Page title={translate('downloadApp.title')} description={translate('downloadApp.description')} sx={{ height: 1 }}>
      <RootStyle>
        <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
          <Typography variant="h3" paragraph sx={{ textAlign: 'center' }}>
            {translate('downloadApp.title')}
          </Typography>
          <BannerSection />
          <Grid container spacing={2}>
            {data.map((item, index) => (
              <Grid item xs={12} md={6} lg={4} key={index}>
                <Card>
                  <CardContent>
                    <Stack spacing={1}>
                      <Stack flexDirection={"row"} alignItems={"center"}>
                        <Image alt={'GPLX Ô tô'} src={`/icons/${item.image}.png`} sx={{ height: 50, width: 50, mr: 1 }} />
                        <Typography variant="subtitle1">{item.title}</Typography>
                      </Stack>
                      <TextMaxLine line={4} persistent variant='body2'>
                        {item.description}
                      </TextMaxLine>
                      <Stack direction={'row'} spacing={2} >
                        <a href={item.android} target='_blank' rel="noreferrer">
                          <Image alt={'Android'} src={`/icons/ic_android.jpg`} sx={{ height: 50, width: 140 }} />
                        </a>
                        <a href={item.ios} target='_blank' rel="noreferrer">
                          <Image alt={'IOS'} src={`/icons/ic_ios.jpg`} sx={{ height: 50, width: 130 }} />
                        </a>
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </RootStyle>
    </Page>
  );
}

function BannerSection() {
  return (
    <Grid container spacing={3} mb={6}>
      <Grid item xs={12} md={12}>
        <Welcome />
      </Grid>
    </Grid>
  );
}
